// extracted by mini-css-extract-plugin
export var lbContainerOuter = "x_tj";
export var lbContainerInner = "x_tk";
export var movingForwards = "x_tl";
export var movingForwardsOther = "x_tm";
export var movingBackwards = "x_tn";
export var movingBackwardsOther = "x_tp";
export var lbImage = "x_tq";
export var lbOtherImage = "x_tr";
export var prevButton = "x_ts";
export var nextButton = "x_tt";
export var closing = "x_tv";
export var appear = "x_tw";